import {useApi} from "../Api";
import {FormSearchLocationGroupProductCodeModel, LocationGroupProductCode,} from "../types/locationGroupProductCode";
import {PagedResponse} from "../types/pagination";
import {SelectElementModelBE, SelectElementModelFE} from "../types/generic";
import {LocationGroupEntityResponse} from "../types/locationGroup";
import {buildQueryParams} from "../../utils";
import {AggregateLocationGroupByRate} from "../types/aggregateLocationGroupByRate";

export const useProductCodeLocationGroupRepository = () => {
    const {GET, POST, DELETE} = useApi();

    const PATH = "/pricing/product-code-location-group";


    function getLocationGroupsByProductCode(productCode: any): Promise<LocationGroupEntityResponse[]> {
        return GET(`${PATH}/get-locations?productCode=${productCode}`);
    }

    function getLocationGroupsByProductCodePaged(filters: any): Promise<PagedResponse<LocationGroupEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter/get-locations${queryParams ? query + queryParams : ""}`);
    }

    function getLocationGroupProductCodesPaged(filters: FormSearchLocationGroupProductCodeModel): Promise<PagedResponse<LocationGroupProductCode>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter/product-code-location-group${queryParams ? query + queryParams : ""}`);
    }

    function getRateAssociations(
        productCode: string,
        legalEntities: string
    ): Promise<AggregateLocationGroupByRate[]> {
        return GET(
            `${PATH}/location-group-and-rate-aggregations?productCode=${productCode}&legalEntities=${legalEntities}`
        );
    }

    function postLocationGroupProductCodeAll(productCodeLocationGroups: LocationGroupProductCode[]): Promise<LocationGroupProductCode[]> {
        return POST(`${PATH}/full`, productCodeLocationGroups);
    }

    function getUnassociatedLocationGroupsByProductCode(
        productCodeId: number,
        legalEntities: String | null
    ): Promise<SelectElementModelBE[]> {
        return GET(
            `${PATH}/unassociated-group-to-product?productCode=${productCodeId}&legalEntities=${legalEntities}`
        );
    }

    function deleteLocationGroupProductCode(locationGroupProductCode: LocationGroupProductCode): Promise<LocationGroupProductCode> {
        return DELETE(`${PATH}?productCodeId=${locationGroupProductCode.id.productCodeId}&locationGroupId=${locationGroupProductCode.id.locationGroupId}`);
    }


    return {
        getLocationGroupsByProductCode,
        getLocationGroupProductCodesPaged,
        getLocationGroupsByProductCodePaged,
        getRateAssociations,
        postLocationGroupProductCodeAll,
        getUnassociatedLocationGroupsByProductCode,
        deleteLocationGroupProductCode,
    };
};